import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';

import { WaitImageComponent } from 'app/shared/components/wait-image.component/wait-image.component';
import { ComponentInfoComponent } from 'app/shared/components/component-info.component/component-info.component';
import { CancelWarningsTableComponent } from 'app/shared/components/cancel-warnings-table.component/cancel-warnings-table.component';
import { NumeralPipe } from 'app/shared/pipes/numeral.pipe';
import { SafeHtmlPipe } from 'app/shared/pipes/safe-HTML.pipe';
import {PeriodSelectorComponent} from "./components/period-selector.component/period-selector.component";
import {CloseBtnComponent} from "./components/close-btn.component/close-btn.component";
import {BackgroundBtnComponent} from "./components/background-btn.component/background-btn.component";
import {SlickGridModule} from "../slick-grid/slick-grid.module";
import {DraggableDirective} from "./directives/draggable.directive";
import {MovableDirective} from "./directives/movable.directive";
import {SortableDirective} from "./directives/sortable.directive";
import {MovableAreaDirective} from "./directives/movable-area.directive";
import {SortableListDirective} from "./directives/sortable-list.directive";
import {DraggableHelperDirective} from "./directives/draggable-helper.directive";
import {BootstrapTooltipDirective} from "./directives/bootstrap-tooltip.directive";
import {StocksToolbarComponent} from "./components/stocks-toolbar.component/stocks-toolbar.component";
import {AgSelectListComponent} from "../stocks/components/ag-select-list.component/ag-select-list.component";
import {AggregationListComponent} from "../stocks/components/aggregations-list.component/aggregations-list.component";
import {SimpleMenuComponent} from "./components/simple-menu.component/simple-menu.component";
import {ChangeFocusDirective} from "./directives/change-focus.directive";
import {ValidationDirective} from "./directives/validation.directive";
import {ExampleGroupingComponent} from "./components/example-grouping.component/example-grouping.component";
import {DlDateTimePickerDateModule, DlDateTimePickerNumberModule} from "../external-components/angular-bootstrap-datetimepicker";
import {DateConvPipe} from "./pipes/date-conv.pipe";
import {DateTimePickerComponent} from "./components/date-time-picker.component/date-time-picker.component";
import {SlickDatetimePickerComponent} from "./components/slick-datetime-picker.component/slick-datetime-picker.component";
import {CommonService} from "../services/common.service";
import {CommonDataService} from "../services/common-data.service";
import {ExcelWorkService} from "../services/excel-work.service";
import {CheckVersions} from "../services/check-versions.service";
import {SaveUserPropService} from "../services/save-user-prop";
import {BufferGraphService} from "../buffer-graph/services/buffer-graph.service";
import {BufferGraphDataExchangeService} from "../buffer-graph/services/buffer-graph-data-exchange.service";
import {StocksFilterService} from "../stocks/services/stocks-filter.service";
import {StocksService} from "../stocks/services/stocks.service";
import {
    FilterSearchCodeNameComponent
} from "../stocks/components/filter-search-code-name.component/filter-search-code-name.component";
import {
    NotValidatedDataComponent
} from "../stocks/components/not-validated-data.component/not-validated-data.component";
import {MainFilterComponent} from "../stocks/components/main-filter.component/main-filter.component";
import {SelectedFilterComponent} from "../stocks/components/selected-filter.component/selected-filter.component";
import {NumberFilterComponent} from "../stocks/components/number-filter.component/number-filter.component";

@NgModule({
    imports: [CommonModule, TranslateModule.forChild(), FormsModule, SlickGridModule, OverlayModule, DlDateTimePickerNumberModule],
    declarations: [
        WaitImageComponent,
        NumeralPipe,
        SafeHtmlPipe,
        ComponentInfoComponent,
        CancelWarningsTableComponent,
        PeriodSelectorComponent,
        CloseBtnComponent,
        BackgroundBtnComponent,
        //UniversalListComponent,
        DraggableDirective,
        MovableDirective,
        MovableAreaDirective,
        DraggableHelperDirective,
        SortableDirective,
        SortableListDirective,
        BootstrapTooltipDirective,
        ValidationDirective,
        StocksToolbarComponent,
        AgSelectListComponent,
        AggregationListComponent,
        SimpleMenuComponent,
        ChangeFocusDirective,
        ExampleGroupingComponent,
        DateConvPipe,
        DateTimePickerComponent,
        SlickDatetimePickerComponent,
        FilterSearchCodeNameComponent,
        NotValidatedDataComponent,
        MainFilterComponent,
        SelectedFilterComponent,
        NumberFilterComponent
    ],
    exports: [
        WaitImageComponent,
        NumeralPipe,
        SafeHtmlPipe,
        ComponentInfoComponent,
        CancelWarningsTableComponent,
        PeriodSelectorComponent,
        CloseBtnComponent,
        BackgroundBtnComponent,
        //UniversalListComponent,
        DraggableDirective,
        MovableDirective,
        MovableAreaDirective,
        DraggableHelperDirective,
        SortableDirective,
        SortableListDirective,
        BootstrapTooltipDirective,
        ValidationDirective,
        StocksToolbarComponent,
        AgSelectListComponent,
        AggregationListComponent,
        SimpleMenuComponent,
        ChangeFocusDirective,
        DateConvPipe,
        DateTimePickerComponent,
        SlickDatetimePickerComponent,
        FilterSearchCodeNameComponent,
        NotValidatedDataComponent,
        MainFilterComponent,
        SelectedFilterComponent,
        NumberFilterComponent
    ],
    entryComponents: [SlickDatetimePickerComponent],

})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                CommonService,
                CommonDataService,
                ExcelWorkService,
                CheckVersions,
                SaveUserPropService
            ] };
    }

    static forChild(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                CommonService,
                CommonDataService,
                ExcelWorkService,
                CheckVersions,
                SaveUserPropService
            ] };
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts